import { ValidateCartResponse } from '@services/orders/interfaces/order.interfaces';
import { Order, OrderSummary } from '@services/orders/interfaces/orders.interfaces';
import { Mock } from '@shared/interfaces/mock.interface';

export const ORDERS_DATA: Order[] = [
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000001',
    orderCode: 'ARG-2025-0001',
    date: '2025-06-24T14:32:00.000Z',
    status: 'completed',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'delivery',
    documentType: 'boleta',
    notes: 'Entregar después de las 18:00.',
    customer: {
      name: 'Camila Rojas',
      email: 'camila.rojas@example.cl',
      phone: '+56 9 8123 4567',
      rut: null,
    },
    shipping: {
      regionCode: '15',
      regionName: 'Arica y Parinacota',
      communeCode: null,
      communeName: 'Arica',
      street: 'Av. Comandante San Martín 2140',
      locality: 'Villa Los Aromos',
    },
    shippingQuote: {
      serviceName: 'EXPRESS',
      packages: [
        { boxCode: 'M', boxLabel: 'Mediana', lengthCm: 30, widthCm: 25, heightCm: 15, weightGrams: 1250, unitsCount: 3, declaredValue: 74000 },
      ],
    },
    invoice: null,
    items: [
      {
        productName: 'Bluey Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 12000,
        lineSubtotal: 12000,
        sizeLabel: 'Mediano',
        colorName: 'Azul',
      },
      {
        productName: 'Dragón Articulado',
        productType: 'standard',
        quantity: 3,
        unitPrice: 18000,
        lineSubtotal: 54000,
        sizeLabel: 'Grande',
        colorName: 'Verde',
      },
      {
        productName: 'Llavero personalizado',
        productType: 'keychain',
        quantity: 2,
        unitPrice: 4000,
        lineSubtotal: 8000,
        keychainType: 'color',
        customName: 'CAMILA',
        thickness: '3mm',
        colorName: 'Negro',
      },
    ],
    totals: {
      subtotal: 74000,
      shippingCost: 4500,
      taxAmount: null,
      net: null,
      total: 78500,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000002',
    orderCode: 'ARG-2025-0002',
    date: '2025-06-24T16:05:00.000Z',
    status: 'pending',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Ignacio Fuentes',
      email: 'ignacio.fuentes@example.cl',
      phone: '+56 9 7411 2299',
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Bluey Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 9000,
        lineSubtotal: 9000,
        sizeLabel: 'Pequeño',
        colorName: 'Celeste',
      },
      {
        productName: 'Maceta hexagonal',
        productType: 'standard',
        quantity: 3,
        unitPrice: 7500,
        lineSubtotal: 22500,
        sizeLabel: 'Mediano',
        colorName: 'Blanco',
      },
    ],
    totals: {
      subtotal: 31500,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 31500,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000003',
    orderCode: 'ARG-2025-0003',
    date: '2025-06-23T11:20:00.000Z',
    status: 'completed',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Valentina Soto',
      email: 'valentina.soto@example.cl',
      phone: '+56 9 6622 8890',
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Pulpo Articulado',
        productType: 'standard',
        quantity: 2,
        unitPrice: 11000,
        lineSubtotal: 22000,
        sizeLabel: 'Mediano',
        colorName: 'Rojo',
      },
    ],
    totals: {
      subtotal: 22000,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 22000,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000004',
    orderCode: 'ARG-2025-0004',
    date: '2025-06-23T09:02:00.000Z',
    status: 'shipped',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'delivery',
    documentType: 'boleta',
    notes: 'Regalo — incluir tarjeta.',
    customer: {
      name: 'Matías Contreras',
      email: 'matias.contreras@example.cl',
      phone: '+56 9 5533 1188',
      rut: null,
    },
    shipping: {
      regionCode: null,
      regionName: 'Tarapacá',
      communeCode: null,
      communeName: 'Iquique',
      street: 'Calle Sotomayor 455, depto 802',
      locality: null,
    },
    invoice: null,
    items: [
      {
        productName: 'Bluey Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 15000,
        lineSubtotal: 15000,
        sizeLabel: 'Grande',
        colorName: 'Azul',
      },
      {
        productName: 'Set de dinosaurios',
        productType: 'standard',
        quantity: 3,
        unitPrice: 21000,
        lineSubtotal: 63000,
        sizeLabel: 'Pequeño',
        colorName: 'Multicolor',
      },
      {
        productName: 'Portalápices',
        productType: 'standard',
        quantity: 1,
        unitPrice: 6500,
        lineSubtotal: 6500,
        sizeLabel: 'Único',
        colorName: 'Gris',
      },
      {
        productName: 'Llavero personalizado',
        productType: 'keychain',
        quantity: 4,
        unitPrice: 5000,
        lineSubtotal: 20000,
        keychainType: 'color',
        customName: 'CAMILA',
        thickness: '3mm',
        colorName: 'Rosado',
      },
    ],
    totals: {
      subtotal: 104500,
      shippingCost: 6900,
      taxAmount: null,
      net: null,
      total: 111400,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000005',
    orderCode: 'ARG-2025-0005',
    date: '2025-06-22T19:48:00.000Z',
    status: 'completed',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Josefa Álvarez',
      email: 'josefa.alvarez@example.cl',
      phone: null,
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Lámpara luna',
        productType: 'standard',
        quantity: 1,
        unitPrice: 28000,
        lineSubtotal: 28000,
        sizeLabel: 'Grande',
        colorName: 'Blanco',
      },
      {
        productName: 'Base de madera',
        productType: 'standard',
        quantity: 1,
        unitPrice: 5000,
        lineSubtotal: 5000,
        sizeLabel: 'Único',
        colorName: null,
      },
    ],
    totals: {
      subtotal: 33000,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 33000,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000006',
    orderCode: 'ARG-2025-0006',
    date: '2025-06-22T13:11:00.000Z',
    status: 'cancelled',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'rejected',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: 'Cliente canceló por WhatsApp.',
    customer: {
      name: 'Rodrigo Peña',
      email: 'rodrigo.pena@example.cl',
      phone: '+56 9 4477 6621',
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Gato Articulado',
        productType: 'standard',
        quantity: 2,
        unitPrice: 10500,
        lineSubtotal: 21000,
        sizeLabel: 'Mediano',
        colorName: 'Naranjo',
      },
    ],
    totals: {
      subtotal: 21000,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 21000,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000007',
    orderCode: 'ARG-2025-0007',
    date: '2025-06-21T15:26:00.000Z',
    status: 'pending',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'delivery',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Antonia Miranda',
      email: 'antonia.miranda@example.cl',
      phone: '+56 9 3390 5512',
      rut: null,
    },
    shipping: {
      regionCode: '15',
      regionName: 'Arica y Parinacota',
      communeCode: null,
      communeName: 'Putre',
      street: 'Pasaje Los Aromos 118',
      locality: 'Villa Los Aromos',
    },
    invoice: null,
    items: [
      {
        productName: 'Llavero personalizado',
        productType: 'keychain',
        quantity: 6,
        unitPrice: 3500,
        lineSubtotal: 21000,
        keychainType: 'color',
        customName: 'CAMILA',
        thickness: '3mm',
        colorName: 'Amarillo',
      },
    ],
    totals: {
      subtotal: 21000,
      shippingCost: 5200,
      taxAmount: null,
      net: null,
      total: 26200,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000008',
    orderCode: 'ARG-2025-0008',
    date: '2025-06-21T10:04:00.000Z',
    status: 'shipped',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'delivery',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Diego Herrera',
      email: 'diego.herrera@example.cl',
      phone: '+56 9 2284 7730',
      rut: null,
    },
    shipping: {
      regionCode: null,
      regionName: 'Antofagasta',
      communeCode: null,
      communeName: 'Antofagasta',
      street: 'Av. Chile 3320',
      locality: null,
    },
    invoice: null,
    items: [
      {
        productName: 'Axolotl Articulado',
        productType: 'standard',
        quantity: 2,
        unitPrice: 8500,
        lineSubtotal: 17000,
        sizeLabel: 'Pequeño',
        colorName: 'Rosado',
      },
      {
        productName: 'Bluey Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 12000,
        lineSubtotal: 12000,
        sizeLabel: 'Mediano',
        colorName: 'Azul',
      },
    ],
    totals: {
      subtotal: 29000,
      shippingCost: 7400,
      taxAmount: null,
      net: null,
      total: 36400,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000009',
    orderCode: 'ARG-2025-0009',
    date: '2025-06-20T17:55:00.000Z',
    status: 'completed',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Francisca Núñez',
      email: 'francisca.nunez@example.cl',
      phone: '+56 9 9012 3344',
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Organizador de escritorio',
        productType: 'standard',
        quantity: 1,
        unitPrice: 16500,
        lineSubtotal: 16500,
        sizeLabel: 'Grande',
        colorName: 'Negro',
      },
      {
        productName: 'Soporte para audífonos',
        productType: 'standard',
        quantity: 2,
        unitPrice: 9000,
        lineSubtotal: 18000,
        sizeLabel: 'Único',
        colorName: 'Negro',
      },
    ],
    totals: {
      subtotal: 34500,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 34500,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000010',
    orderCode: 'ARG-2025-0010',
    date: '2025-06-20T08:19:00.000Z',
    status: 'pending',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: 'Pago pendiente por transferencia.',
    customer: {
      name: 'Sebastián Vidal',
      email: 'sebastian.vidal@example.cl',
      phone: '+56 9 6708 4415',
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Tiburón Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 19000,
        lineSubtotal: 19000,
        sizeLabel: 'Grande',
        colorName: 'Gris',
      },
      {
        productName: 'Llavero personalizado',
        productType: 'keychain',
        quantity: 3,
        unitPrice: 4500,
        lineSubtotal: 13500,
        keychainType: 'color',
        customName: 'CAMILA',
        thickness: '3mm',
        colorName: 'Azul',
      },
    ],
    totals: {
      subtotal: 32500,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 32500,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000011',
    orderCode: 'ARG-2025-0011',
    date: '2025-06-19T21:37:00.000Z',
    status: 'shipped',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'paid',
    shippingType: 'delivery',
    documentType: 'boleta',
    notes: null,
    customer: {
      name: 'Paula Carrasco',
      email: 'paula.carrasco@example.cl',
      phone: '+56 9 5590 6677',
      rut: null,
    },
    shipping: {
      regionCode: null,
      regionName: 'Coquimbo',
      communeCode: null,
      communeName: 'La Serena',
      street: 'Los Nogales 890',
      locality: 'Villa Los Aromos',
    },
    invoice: null,
    items: [
      {
        productName: 'Set de macetas',
        productType: 'standard',
        quantity: 4,
        unitPrice: 6000,
        lineSubtotal: 24000,
        sizeLabel: 'Pequeño',
        colorName: 'Terracota',
      },
    ],
    totals: {
      subtotal: 24000,
      shippingCost: 8100,
      taxAmount: null,
      net: null,
      total: 32100,
    },
  },
  {
    id: 'a1f3c0d2-1111-4a01-9c11-000000000012',
    orderCode: 'ARG-2025-0012',
    date: '2025-06-19T12:08:00.000Z',
    status: 'cancelled',
    statusReason: null,
    trackingCode: null,
    paymentStatus: 'rejected',
    shippingType: 'pickup',
    documentType: 'boleta',
    notes: 'Sin stock del color solicitado.',
    customer: {
      name: 'Tomás Bravo',
      email: 'tomas.bravo@example.cl',
      phone: null,
      rut: null,
    },
    shipping: null,
    invoice: null,
    items: [
      {
        productName: 'Bluey Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 12000,
        lineSubtotal: 12000,
        sizeLabel: 'Mediano',
        colorName: 'Azul',
      },
      {
        productName: 'Bingo Articulado',
        productType: 'standard',
        quantity: 1,
        unitPrice: 12000,
        lineSubtotal: 12000,
        sizeLabel: 'Mediano',
        colorName: 'Naranjo',
      },
    ],
    totals: {
      subtotal: 24000,
      shippingCost: 0,
      taxAmount: null,
      net: null,
      total: 24000,
    },
  },
];

/** Listing rows, mirroring the lighter payload the admin endpoint returns. */
export const ORDER_SUMMARIES_DATA: OrderSummary[] = ORDERS_DATA.map((order) => ({
  id: order.id,
  orderCode: order.orderCode,
  title: order.items.map((item) => `${item.quantity}x ${item.productName}`).join(', '),
  date: order.date,
  status: order.status,
  paymentStatus: order.paymentStatus,
  shippingType: order.shippingType,
  total: order.totals.total,
}));

export const GET_ORDERS_MOCK: Mock = {
  success: [{ response: { data: ORDER_SUMMARIES_DATA, page: 1, limit: 20, total: ORDER_SUMMARIES_DATA.length, totalPages: 1 } }],
  failures: [{ response: { message: 'Error loading orders', statusCode: 500 } }],
};

export const GET_ORDER_STATUS_COUNTS_MOCK: Mock = {
  success: [
    {
      response: {
        all: ORDER_SUMMARIES_DATA.length,
        byStatus: {
          pending: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'pending').length,
          shipped: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'shipped').length,
          completed: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'completed').length,
          cancelled: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'cancelled').length,
          returned: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'returned').length,
          payment_failed: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'payment_failed').length,
        },
        pendingByShippingType: {
          delivery: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'pending' && order.shippingType === 'delivery').length,
          pickup: ORDER_SUMMARIES_DATA.filter((order) => order.status === 'pending' && order.shippingType === 'pickup').length,
        },
        unconfirmedPayments: ORDER_SUMMARIES_DATA.filter((order) => order.paymentStatus === 'unconfirmed').length,
      },
    },
  ],
  failures: [{ response: { message: 'Error loading order counts', statusCode: 500 } }],
};

export const GET_ORDER_DETAIL_MOCK: Mock = {
  success: [{ response: ORDERS_DATA[0] }],
  failures: [{ response: { message: 'Order not found', statusCode: 404 } }],
};

/** El endpoint real responde 204 No Content. */
export const UPDATE_ORDER_STATUS_MOCK: Mock = {
  success: [{ response: null }],
  failures: [{ response: { code: 20001, message: 'Order status transition not allowed', statusCode: 409 } }],
};

/** Por defecto el carrito está sano: todo disponible y sin cambios de precio. */
/**
 * La respuesta trae una línea por ítem enviado y en el mismo orden, así que un
 * mock estático solo calza con un carrito del mismo largo. Con otro largo el
 * front deja el carrito intacto a propósito, en vez de vaciarlo por error.
 */
export const COMING_SOON_CART_RESPONSE_MOCK: ValidateCartResponse = {
  items: [{
    available: false,
    productName: 'Bluey Articulado',
    unitPrice: null,
    quantity: 1,
    lineSubtotal: null,
    hasHomeDelivery: false,
    reasonCode: 'coming_soon',
    reason: 'Product is not purchasable',
  }],
  subtotal: 0,
  isDeliveryAvailable: true,
};

export const PRODUCT_NOT_PURCHASABLE_RESPONSE_MOCK = {
  statusCode: 400,
  code: 10011,
  message: 'Product is not purchasable',
};

export const VALIDATE_CART_MOCK: Mock = {
  success: [
    {
      response: {
        items: [
          {
            available: true,
            productName: 'Bluey Articulado',
            unitPrice: 12000,
            quantity: 1,
            lineSubtotal: 12000,
            hasHomeDelivery: true,
            reasonCode: null,
            reason: null,
          },
        ],
        subtotal: 12000,
        isDeliveryAvailable: true,
      },
    },
    {
      response: {
        items: [
          {
            available: false,
            productName: null,
            unitPrice: null,
            quantity: 1,
            lineSubtotal: null,
            hasHomeDelivery: false,
            reasonCode: 'unavailable',
            reason: 'Este producto ya no está disponible',
          },
        ],
        subtotal: 0,
        isDeliveryAvailable: true,
      },
    },
  ],
  failures: [{ response: { message: 'Error validating cart', statusCode: 500 } }],
};

export const ORDER_MOCKS: Mock = {
  success: [
    {
      response: {
        id: 'c1a9f3e0-1234-4a1b-8b2a-000000000001',
        orderCode: 'ARG-2026-0001',
      },
    },
  ],
  failures: [
    {
      response: {
        ...PRODUCT_NOT_PURCHASABLE_RESPONSE_MOCK,
      },
    },
    // Producto caído entre la revalidación y el pago: lo que el front mira es
    // `reasonCode`, no el status.
    {
      response: {
        statusCode: 400,
        message: "El producto 'Bluey Articulado' no está disponible",
        reasonCode: 'PRODUCT_INACTIVE',
        productId: 'c1a9f3e0-1234-4a1b-8b2a-000000000010',
      },
    },
    // Error genérico: sin `reasonCode`, así que no es de catálogo.
    {
      response: {
        message: ['El producto seleccionado ya no está disponible.'],
      },
    },
  ],
};

export const INIT_PAYMENT_MOCKS: Mock = {
  success: [
    {
      response: {
        url: '/pago/retorno/mock-order-id',
      },
    },
  ],
  failures: [
    {
      response: {
        message: ['No se pudo iniciar el pago. Intenta nuevamente en unos minutos.'],
      },
    },
  ],
};

export const PAYMENT_STATUS_MOCK: Mock = {
  success: [{ response: { orderCode: '1111111', paymentStatus: 'paid' } }],
  failures: [{ response: { message: ['Order not found'] } }],
};

export const CANCEL_PAYMENT_MOCK: Mock = {
  success: [{ response: { orderCode: '1111111', paymentStatus: 'rejected' } }],
  failures: [{ response: { message: ['Order not found'] } }],
};
